// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = require("!!../../../../node_modules/style-loader/index.js!../../../../node_modules/css-loader/index.js!./notification-alert.component.css");

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}


//////////////////
// WEBPACK FOOTER
// ./app/core/components/notification/notification-alert.component.css
// module id = 873
// module chunks = 7